import { Component, OnDestroy } from '@angular/core'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { AuthService } from '@app/core/service/auth.service'
import { BootstrapSelectors } from '@app/core/store/selectors/bootstrap.selector'
import { ScopingSelectors } from '@app/features/scoping/store/selectors/scoping.selector'
import { TableColumnPreferences } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'
import { Store } from '@ngrx/store'
import { plainToInstance } from 'class-transformer'
import { combineLatest, filter, map, Observable } from 'rxjs'
import { UserSettingsService } from '../../service/user-settings.service'
import { ScopeOverviewSelectors } from '../../store/selectors/scope-overview.selector'
import { ChangeRequestActions } from '../store/actions/change-request.actions'
import { ChangeRequestSelectors } from '../store/selectors/change-request.selectors'
import { getScopeChanges } from '../util/entity-changes'
import { getFeeChanges } from '../util/entity-changes/get-fee-changes.util'

@Component({
  selector: 'change-request-container',
  template: `<change-request
    [currentScope]="currentScope$ | async"
    [changeRequests]="changeRequests$ | async"
    [currentChangeRequest]="currentChangeRequest$ | async"
    [cdnConfig]="cdnConfig$ | async"
    [currentChangeRequestAbleToMerge]="currentChangeRequestAbleToMerge$ | async"
    [filterPreferences]="filterPreferences$ | async" />`,
})
export class ChangeRequestContainerComponent implements OnDestroy {
  currentScope$: Observable<ScopeVersion> = combineLatest([
    this.store$.select(ScopeOverviewSelectors.selectCurrentScope),
    this.store$.select(ChangeRequestSelectors.selectPreviewScope),
  ]).pipe(
    filter(([currentScope]) => !!currentScope),
    map(([currentScope, previewScope]) =>
      plainToInstance(ScopeVersion, {
        ...currentScope,
        deliverables: previewScope?.deliverables || currentScope.deliverables,
        calculatedValues: previewScope?.calculatedValues || currentScope.calculatedValues,
        feeItems: getFeeChanges(currentScope.feeItems, previewScope?.feeItems),
        changes: getScopeChanges(currentScope, previewScope),
      })
    )
  )

  changeRequests$: Observable<ChangeRequest[]> = this.store$.select(ChangeRequestSelectors.selectChangeRequests)
  currentChangeRequest$: Observable<ChangeRequest> = this.store$.select(
    ChangeRequestSelectors.selectCurrentChangeRequest
  )

  currentChangeRequestAbleToMerge$: Observable<boolean> = this.store$.select(
    ChangeRequestSelectors.changeRequestAbleToMerge
  )
  cdnConfig$: Observable<CdnConfig | undefined> = this.store$.select(BootstrapSelectors.selectCdnConfig)
  filterPreferences$: Observable<TableColumnPreferences> = this.store$.select(
    ScopingSelectors.selectScopeOverviewColumns
  )

  constructor(
    private store$: Store,
    protected authService: AuthService,
    protected userSettingsService: UserSettingsService
  ) {}

  ngOnDestroy() {
    this.store$.dispatch(ChangeRequestActions.resetCurrentChangeRequest())
  }
}
